import React, { useContext } from "react";
import style from "./index.module.scss";
import { Button, Icon, message } from "antd";
import { CourseContext } from "../../../../Store";
import CourseHeader from "../../../../components/CourseHeader";
import useRequest from "utils/useRequest";
import {
    QuestionStatus,
    getQuestionnaireList,
    publishQuestionnaire,
    convertMinutesToDHMText
} from "service/question";
import moment from "moment";
import { errorMessage } from "../../../../../../service/service";
import useRequestFn from "../../../../../../utils/useRequestFn";
import { useHistory } from "react-router-dom";

interface ExerciseTopicsHeaderProps {
    questionnaireId: string;
    visible: boolean;
    reload: () => void;
}

export default function QuestionTopicsHeader({
    questionnaireId,
    visible,
    reload
}: ExerciseTopicsHeaderProps) {
    const { course } = useContext(CourseContext);
    const { weekTimeId } = course;
    const [dataList] = useRequest(() => getQuestionnaireList(weekTimeId), {}, [
        weekTimeId
    ]);
    const currentData = dataList?.find(
        item => item.id === Number(questionnaireId)
    );

    const status =
        currentData &&
        currentData.questionnaireCount < 1 &&
        currentData?.questionnaireStatus === 0
            ? QuestionStatus.NoChild
            : currentData?.questionnaireStatus;

    const [startAction, { loading: startLoading }] =
        useRequestFn(publishQuestionnaire);

    const { basename } = useContext(CourseContext);
    const history = useHistory();
    async function startQuestion() {
        try {
            await startAction(weekTimeId, parseInt(questionnaireId));
            history.replace(`${basename}/question/detail/${questionnaireId}`);
        } catch (e) {
            message.error(errorMessage(e));
        }
    }
    return (
        <CourseHeader
            title={currentData?.description ? currentData.description : ""}
            info={
                <div>
                    <span>
                        活动时长 &nbsp;
                        {convertMinutesToDHMText(currentData?.validityTime)}
                    </span>

                    {(currentData?.startTime || currentData?.endTime) && (
                        <span>
                            &nbsp;|&nbsp;
                            {(status === QuestionStatus.doing ||
                                status === QuestionStatus.done) &&
                                currentData.startTime && (
                                    <>
                                        开始时间
                                        {moment(currentData.startTime).format(
                                            "MM-DD HH:mm"
                                        )}
                                        &nbsp;&nbsp;
                                    </>
                                )}
                            {status === QuestionStatus.done &&
                                currentData.endTime && (
                                    <>
                                        结束时间
                                        {moment(currentData.endTime).format(
                                            "MM-DD HH:mm"
                                        )}
                                    </>
                                )}
                        </span>
                    )}
                </div>
            }
            extra={
                <Button
                    type="primary"
                    className={style.button}
                    onClick={startQuestion}
                    loading={startLoading}
                    disabled={!visible}>
                    <Icon type="flag" theme="filled" /> 开始问卷
                </Button>
            }
        />
    );
}
